module.exports = __webpack_public_path__ + "static/img/stady.87de86d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/stady.jpg
// module id = wxB1
// module chunks = 1